import { QueryClient } from "@tanstack/react-query";

const defaultStaleTime = 60 * 1000; // 1 minute
const defaultGcTime = 5 * 60 * 1000; // 5 minutes (formerly cacheTime)

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: defaultStaleTime,
      gcTime: defaultGcTime,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
